import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/Index/banner.png'
import _imports_1 from '../assets/images/Index/banner2.jpg'
import _imports_2 from '../assets/images/Index/userFlow.png'
import _imports_3 from '../assets/images/Index/change.png'


const _withScopeId = n => (_pushScopeId("data-v-2af6359a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "banner",
  style: {"height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"display":"block","width":"100%","height":"100%"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://qkl.ylxue.net/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {"display":"block","width":"100%","height":"100%"}
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "min-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrap-container" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "index_classify mt50" }, [
      /*#__PURE__*/_createElementVNode("span", null, "我们的优势")
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      class: "index_classify",
      src: _imports_2,
      style: {"margin":"0 auto 50px"}
    })
  ])
], -1))
const _hoisted_5 = { style: {"background":"#F9F9F9"} }
const _hoisted_6 = { class: "wrap-container py50" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "index_classify" }, [
  /*#__PURE__*/_createElementVNode("span", null, "精品课程推荐")
], -1))
const _hoisted_8 = { class: "course_container" }
const _hoisted_9 = { class: "course_title" }
const _hoisted_10 = { class: "course_type" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "course_change" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_14 = { class: "course_box mt20 flex" }
const _hoisted_15 = { class: "w100 h100" }
const _hoisted_16 = { class: "course-list flex flex-wrap mb30" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "title p5 mt15 text-line-1" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "title p5 mt15 text-line-1" }
const _hoisted_21 = { class: "course-list flex flex-wrap" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "title p5 mt15 text-line-1" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "title p5 mt15 text-line-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "questions_title",
  style: {"display":"none"}
}, "题库导航", -1))
const _hoisted_27 = {
  class: "questions_container",
  style: {"display":"none"}
}
const _hoisted_28 = ["href"]

import {useStore} from 'vuex'
import axios from "axios";
import {reactive, ref, onMounted, getCurrentInstance} from 'vue';

import AspectRatio from "@/components/AspectRatio.vue";
import Login from '@/components/login.vue';
import Teacher from '@/components/Teacher.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const loginRef = ref()
// 获取自定义接口
const publicApiUrl = getCurrentInstance().appContext.config.globalProperties.$publicPath.publicApiUrl;

// 获取apiUrl
const store = useStore();
const isShow = ref(false)
const data: any = reactive({
  logged: store.state.logged,
  noticeItems: [],
  classifyItems: [
    {
      id: '69',
      title: '护理专业',
    },
    {
      id: '84',
      title: '畜牧业',
    },
    {
      id: '36',
      title: '农业',
    },
    {
      id: '45',
      title: '水利水电',
    },
    {
      id: '53',
      title: '人力资源管理',
    },
    {
      id: '23',
      title: '市政城建工程',
    },
  ],
  courseItems: [],
  questionsItems: [
    {
      name: '环境保护工程',
      num: '89',
      link: '/sss',
    },
    {
      name: '法律',
      num: '222',
      link: '/ddd',
    },
    {
      name: '美术',
      num: '333',
      link: '/fff',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/ggg',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/sss',
    },
    {
      name: '法律',
      num: '222',
      link: '/ddd',
    },
    {
      name: '美术',
      num: '333',
      link: '/fff',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/ggg',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/sss',
    },
    {
      name: '法律',
      num: '222',
      link: '/ddd',
    },
    {
      name: '美术',
      num: '333',
      link: '/fff',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/ggg',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/sss',
    },
    {
      name: '法律',
      num: '222',
      link: '/ddd',
    },
    {
      name: '美术',
      num: '333',
      link: '/fff',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/ggg',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/sss',
    },
    {
      name: '法律',
      num: '222',
      link: '/ddd',
    },
    {
      name: '美术',
      num: '333',
      link: '/fff',
    },
    {
      name: '环境保护工程',
      num: '89',
      link: '/ggg',
    },
  ],
  superiorityItems: [
    {
      title: '原创课程多',
      describe: '目前原创课程达到3650课时',
    },
    {
      title: '师资力量雄厚',
      describe: '合作名校名师1200多名',
    },
    {
      title: '合作客户多',
      describe: '全国合作客户已达2018个',
    },
    {
      title: '培训人数多',
      describe: '全国培训人数达到6285932人',
    },
    {
      title: '涉及专业多',
      describe: '涉及全国43个专业',
    },
  ],
  courseId: '69',
});


// 课程分类切换专业
const changeType: any = (id: any) => {
  data.courseId = id;
  $('.course_type span').removeClass('act');
  for (var i = 0; i < data.classifyItems.length; i++) {
    if (id == data.classifyItems[i].id) {
      $('.course_type span').eq(i).addClass('act');
      break;
    }
  }
  getCourseData();
};
// 课程分类本专业切换课程展示
const changeCourse: any = () => {
  getCourseData();
};

// 获取课程分类中的课程
const getCourseData: any = () => {
  axios.post(publicApiUrl.GetRecommendResource, {
    PageIndex: 1,
    PageSize: 10,
    IsTop: 1,
    FirsttypeId: data.courseId,
  }).then(function (res) {
        if (res.status == 200) {
          data.courseItems = [];
          for (var i of res.data) {
            data.courseItems.push({
              title: i.CourseName,
              imgSrc: 'https://ylxue-bucket.oss-cn-beijing.aliyuncs.com/' + i.PcImg,
              href: '/CourseDetails?id=' + i.CourseCode,
              star: '',
              num: '',
            })
          }

        } else {
          console.error(res);
        }
      },
      function (res) {
        console.error(res);
      }
  );
};

onMounted(() => {
  // 获取公告数据
  // axios.post(publicApiUrl.GetNoticePage, {
  // 	current: 1,
  // 	size: 999,
  // 	s_webSite: store.state.s_webSite,
  // }).then(function (res) {
  // 			if (res.status == 200) {
  // 				data.noticeItems = [];
  // 				for (var i of res.data.data) {
  // 					data.noticeItems.push({
  // 						link: '/AnnouncementDetails?id=' + i.i_id,
  // 						title: '[' + new Date(parseInt(i.s_createTime) * 1000).toLocaleDateString().slice().replace(/\//g, '-') + '] ' + i.s_title,
  // 					})
  // 				}
  // 			} else {
  // 				console.error(res);
  // 			}
  // 		},
  // 		function (res) {
  // 			console.error(res);
  // 		}
  // );
  getCourseData();
})

const showLogin = () => {
  loginRef.value.entryVisible = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AspectRatio, {
      width: "100%",
      ratio: 0.31
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_carousel, {
            trigger: "click",
            style: {"height":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_carousel_item, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_carousel_item, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.classifyItems, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  onClick: ($event: any) => (changeType(item.id)),
                  class: _normalizeClass({ act:index == 0 }),
                  key: item
                }, _toDisplayString(item.title), 11, _hoisted_11))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeCourse()))
              }, [
                _createTextVNode(" 换一换 "),
                _hoisted_13
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courseItems, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                    (index<5)
                      ? (_openBlock(), _createBlock(AspectRatio, {
                          key: 0,
                          class: "course-item",
                          ratio: "0.77"
                        }, {
                          default: _withCtx(() => [
                            (_unref(store).state.logged)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "course-content",
                                  to: item.href,
                                  title: item.title
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(AspectRatio, {
                                      width: "100%",
                                      ratio: "0.55"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          class: "img",
                                          src: item.imgSrc
                                        }, null, 8, _hoisted_17)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "title"]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "course-content",
                                  onClick: showLogin
                                }, [
                                  _createVNode(AspectRatio, {
                                    width: "100%",
                                    ratio: "0.55"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        class: "img",
                                        src: item.imgSrc
                                      }, null, 8, _hoisted_19)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1)
                                ]))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courseItems, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                    (index<10 && index>=5)
                      ? (_openBlock(), _createBlock(AspectRatio, {
                          key: 0,
                          class: "course-item",
                          ratio: "0.77"
                        }, {
                          default: _withCtx(() => [
                            (_unref(store).state.logged)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "course-content",
                                  to: item.href,
                                  title: item.title
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(AspectRatio, {
                                      width: "100%",
                                      ratio: "0.55"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          class: "img",
                                          src: item.imgSrc
                                        }, null, 8, _hoisted_22)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "title"]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "course-content",
                                  onClick: showLogin
                                }, [
                                  _createVNode(AspectRatio, {
                                    width: "100%",
                                    ratio: "0.55"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        class: "img",
                                        src: item.imgSrc
                                      }, null, 8, _hoisted_24)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1)
                                ]))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]),
          _createVNode(Login, {
            ref_key: "loginRef",
            ref: loginRef
          }, null, 512)
        ])
      ])
    ]),
    _createVNode(Teacher),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.questionsItems, (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item,
          href: item.link
        }, _toDisplayString(item.name) + "(" + _toDisplayString(item.num) + ")", 9, _hoisted_28))
      }), 128))
    ])
  ]))
}
}

})